import { useEffect, useState } from 'react';

import { EnumOption } from '../../modules/types/types';
import httpClient from '../httpClient';

export const useProaqFase = () => {
  const [proaqFase, setProaqFase] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchProaqFase = async () => {
      try {
        const response = await httpClient.get(`/api/proaqfase/proaqFase`);

        const options = response.data.map(
          (proaqFase: { value: number; label: string }) => ({
            value: proaqFase.value.toString(),
            label: proaqFase.label,
          }),
        );
        setProaqFase(options);
      } catch (error) {
        console.error('Erro ao buscar Fase do Processo Aquisitivo', error);
      }
    };

    fetchProaqFase();
  }, []);

  return proaqFase;
};
